import { useState } from 'react';
import LoginByEmail from './login/login-by-email';
import LoginByMobile from './login/login-mobile';

const UserSignin = ({ t, setAuth }) => {
  const [show, setShow] = useState('loginemail');

  return (
    <section className='mt-3 sm:mt-5'>
      <div className='text-center text-sm *:ms-1 sm:text-lg'>
        <span className='font-bold text-primary'>
          {t('If you have an account')}
        </span>
        <span className='text-[#787272]'>
          , {t('Log in using your email.')}
        </span>
        <div className='grid grid-cols-2 gap-4 pt-4'>
          {['loginemail', 'loginphone'].map((type) => (
            <button
              className={`w-full py-2 ${type === show ? 'border-b border-b-primary text-primary' : ''}`}
              onClick={() => setShow(type)}
              key={type}
            >
              {t(type)}
            </button>
          ))}
        </div>

        {show === 'loginemail' ? (
          <LoginByEmail t={t} setAuth={setAuth} />
        ) : (
          <LoginByMobile t={t} setAuth={setAuth} />
        )}
      </div>
    </section>
  );
};

export default UserSignin;
